import React from 'react';

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import CircularProgressBar from '_molecules/CircularProgressBar';

import Image from 'react-bulma-companion/lib/Image';

import check from '_assets/icons/check.svg';

export default function ProgressCircle({ progress, timeEstimate, saved = false }) {
  return (
    <div className='progress_wrapper'>
      <div className="progress_circle">
        <CircularProgressBar 
          value={progress} 
          text={`${progress}%`}
          size={100} 
          strokeWidth={16.74}
          styles={buildStyles({
            pathColor: "#2F6FBE",
            trailColor: "#F2F3F7",
            textColor: "#2F6FBE",
          })}/>
      </div>

      <div className='estimate'>
        Est. time to complete: <br/>{timeEstimate}
      </div>
      
      {saved && <div className='saved'>
        <Image className="check"><Image.Content src={check} draggable="false"/></Image>
        <span>Your progess saved</span>
      </div>}
    </div>
  );
}
